define('static/js/undestroy', function(require, exports, module) {

  const { data } = require('static/js/jquery');
  var api = require('static/js/api')
  var undestroyObj = {
    init: function () {
      require(['static/js/jquery','static/js/common','static/js/proxy','static/js/cookie','static/js/jQueryMd5'], function ($, commonJS, proxyJS, cookieJS) {
        initDestroy();
        function initDestroy() {
          var time = 15;
          var flag = false
          var phone = null
          var cookie = cookieJS.cookie;
          var _cookieUserkey = cookieJS.cookie('userkey');
          var _cookieUserName = cookieJS.cookie('username');
          var appID = proxyJS.proxyObj.appId;
          var channelID = proxyJS.proxyObj.channelID;
          var subChannelID = proxyJS.proxyObj.subChannelID
          var appKey = proxyJS.proxyObj.appKey;
          var username = _cookieUserName;
          var accessToken = cookie('userkey');
          var from = 'pc';
  
          // var signatureStr = appID + username + from + appKey;//appId+username+from+appkey
          // var signature = $.md5(signatureStr);
          if (String(_cookieUserkey) == 'null' || String(_cookieUserkey) == 'undefined') {
            window.location.href = '/passport/';
          } else {
            commonJS.commonObj.init();
            setup1()
            function setup1() {
              
              api.undestroyTesting({
                username: username,
                appID: appID,
                channelID: channelID,
                subChannelID: subChannelID,
                appKey: appKey,
                accessToken: cookie('userkey')
              }, function (r) {
                phone = r.data.phone
                $("#destroy_tel").text(phone)
                // $(".logout-condition").removeClass('on')
                $(".loyout-req").addClass('on')
              })
              // function Time() {
              //   time--
              //   $("#unMailt-Btn").html('确认提交 ' + time + "秒")
              // }
              // const clearTime = setInterval(() => {
              //   Time()
              // }, 1000);
              // // obj()
              // setTimeout(() => {
              //   clearInterval(clearTime)
              //   $("#unMailt-Btn").html('确认提交')
              //   flag = true
              // }, 15000);
              // // setp 1 确认点击事件
              // $(".condition-check-icon").click(function () {
              //   if (flag) {
              //     $(".condition-check-icon").toggleClass("condition-check-icon-on")
              //     $(".condition-btn").toggleClass("condition-btn-on")
              //   }
              // })
              // $("#unMailt-Btn").click(function () {
              //   api.destroyTesting({
              //     username: username,
              //     appID: appID,
              //     channelID: channelID,
              //     subChannelID: subChannelID,
              //     appKey: appKey,
              //     accessToken: cookie('userkey')
              //   }, function (r) {
              //     phone = r.data.phone
              //     $("#destroy_tel").text(phone)
              //     $(".logout-condition").removeClass('on')
              //     $(".loyout-req").addClass('on')
              //   })
              // })
            }
            setup2()
            function setup2() {
              var _isRealName = false;
  
              $('#realBtn').click(function () {
                var cardName = String($('#realName').val());
                var cardNameDef = $('#realName')[0].defaultValue;
                var cardNum = String($('#realNum').val());
                var cardInfo = isCardID(cardNum);
                var errorStr = '';
                function succFunc(res) {
                  // $(".loyout-req").removeClass('on')
                  // $(".loyout-info").addClass('on')
                  $('.destroyTip').show()
                }
  
                function reqFailRealNameFunc(res) {
                  alert(res.msg);
                }
                var $ele = $('#realName');
                var oldStr = $ele.val();
                $ele.val(oldStr.replace(/[^\u4e00-\u9fa5]/g, ''));
                var nowVal = $ele.val();
                if (nowVal == '') {
                  $ele.val(this.defaultValue);
                } else {
                  _isRealName = true;
                }
  
  
                if (cardName == cardNameDef) {
                  errorStr = "请输入真实姓名";
                } else if (_isRealName == false) {
                  errorStr = "请输入有效的真实姓名";
                } else if (cardInfo == '') {  //有效的身份证号码*/
                  api.unapplySubmit({
                    captcha: String($('#layout-tp-code').val()),
                    username: username,
                    realname: cardName,
                    idcard: cardNum,
                    appID: appID,
                    channelID: channelID,
                    subChannelID: subChannelID,
                    appKey: appKey,
                    accessToken: cookie('userkey')
                  }, function (r) {
                    // console.log(r)
                    succFunc(r)
                  })
  
                } else {
                  errorStr = cardInfo;
                }
  
                if (errorStr != '') {
                  alert(errorStr);
                }
              });
              function isCardID(sId) {
                var iSum = 0;
                var info = "";
  
                if (!/^\d{17}(\d|x)$/i.test(sId)) {
                  info = "你输入的身份证长度或格式错误";
                } else {
                  sId = sId.replace(/x$/i, "a");
                }
  
  
                var sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
                var d = new Date(sBirthday.replace(/-/g, "/"));
                if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
                  info = "身份证上的出生日期非法";
                }
                for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
                if (iSum % 11 != 1) {
                  info = "请输入有效的身份证号码";
                }
  
  
                return info;
  
              }
  
  
            }
            commonJS.commonObj.controlWarnTips('#login-codeRightTip', '#login-codeErrorTip', true, false, '');
  
            // commonJS.commonObj.controlWarnTips('#login-pwdRightTip', '#login-pwdErrorTip', false, false, 'error');
            // alert('帐号注销申请成功，帐号注销申请确定7-8天，期间可以返回帐号页面进行取消注销操作',window.open('https://fanyi.baidu.com/#en/zh/logout'))
            setup3()
            function setup3() {
              $('#realBtn2').click(function () {
                var cardName = String($('#realName').val());
  
                var cardNum = String($('#realNum').val());
  
                var cancel_reason = $("input:checkbox[name='Fruit']:checked").map(function (index, elem) {
                  return $(elem).val();
                }).get().join(',');
  
                function succFunc(res) {
                  $('.destroyTip').show()
                }
  
  
                api.unapplySubmit({
                  captcha: String($('#layout-tp-code').val()),
                  username: username,
                  realname: cardName,
                  idcard: cardNum,
                  appID: appID,
                  channelID: channelID,
                  subChannelID: subChannelID,
                  appKey: appKey,
                  cancel_reason: cancel_reason,
                  game_recommend: String($('#game_recommend').val()),
                  other_reason: String($('#other_reason').val()),
                  accessToken: cookie('userkey')
                }, function (r) {
                  // console.log(r)
                  succFunc(r)
                })
  
              })
  
              $('.destroyTipBtn').click(function(){
                window.location.href='./accLogin.html'
              })
            }
  
  
            // $(".logout-condition").removeClass('on')
            // $(".loyout-req").addClass('on')
            // $(".loyout-req").removeClass('on')
            // $(".loyout-info").addClass('on')
  
  
            //获取验证码
            ; (function () {
              var _isOldCooling = false;
              var _isOldId = 0;
              var _isOldTotalTime = 60;
  
              function startOldCooling() {
                clearInterval(_isOldId);
                _isOldCooling = true;
                _isOldTotalTime = 60;
                _isOldId = setInterval(updateOldCooking, 1000);
                $('#layout-tp-codeBtn').html(_isOldTotalTime + "秒后重发").addClass('disabled');
              }
  
              function updateOldCooking() {
                _isOldTotalTime--;
                $('#layout-tp-codeBtn').html(_isOldTotalTime + "秒后重发");
                if (_isOldTotalTime <= 0) {
                  clearInterval(_isOldId);
                  _isOldCooling = false;
                  $('#layout-tp-codeBtn').html('获取验证码').removeClass('disabled');
                }
              }
              $('#layout-tp-codeBtn').click(function () {
                if (_isOldCooling == true) {
                  return;
                } else {
                  startOldCooling();
                  var type = 'phone';
                  var succFunc = function (res) {
  
                  }
                  var errorFunc = function (res) {
                    alert(res.msg);
                  }
                  api.captchaindex({
                    username: cookie('username'),
                    appID: appID,
                    type: 'phone',
                    from: 'cancelAccountRemoveValidate',
                    channelID: channelID,
                    subChannelID: subChannelID,
                    appKey: appKey,
                    binding: '',
                    accessToken: accessToken
                  }, function (r) {
                    // console.log(r)
                    succFunc(r)
                  })
                  // proxyJS.proxyObj.reqOldPhoneOrOldMailCapchaAjax({
                  //     action: 'boundVerify',
                  //     appId: appId,
                  //     type: type,
                  //     signature: signature,
                  //     accessToken: accessToken,
                  //     success: succFunc,
                  //     error: errorFunc
                  // });
                }
              });
            })();
  
  
  
  
  
          }
        }
      })
    }
  }
  exports.undestroyObj = undestroyObj;

});
